import React from 'react';
import Loader from '../../Shared/LocalLoader/LocalLoader';
import ContentArea from '@episerver/spa-core/Components/ContentArea';

const ClientLocationMainComponent = ({contentData, context}) => {
  let content = <Loader />;

  content = (
    <div className='client-location-page__container'>
      <ContentArea context={context} data={contentData.mainContentArea} propertyName='mainContentArea' />
    </div>
  );

  return <div className='client-location-page'>{content}</div>;
};

export default ClientLocationMainComponent;
